import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';
import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';

/**
 * Classe responsavel pelo gerenciamento de permissões do android!
 * @author Starley Cazorla
 */

@Injectable({
    providedIn: 'root'
})
export class AndroidService {
    resultadoPermissao: any;
    temPermissaoGps: boolean = false;
    temPermissaoFile: boolean = false;
    temPermissaoReadFile: boolean = false;

    constructor(private androidPermissions: AndroidPermissions,
        private platform: Platform) { }

    async checkPermissions() {
        if (this.platform.is('cordova')) {
            await this.getPermissaoGPS();
            await this.getPermissaoGPSBackgound();
            await this.getPermissaoArmazenamento();
            await this.getPermissaoLeituraArmazenamento();
        }
    }

    // Metodo para verificar permissao
    async getPermissaoGPS() {

        await this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.ACCESS_FINE_LOCATION).then((result: { hasPermission: boolean; }) => {
            console.log('Tem permissao de GPS?', result.hasPermission);
            this.temPermissaoGps = result.hasPermission;
        }).catch(async (res: any) => {
            console.log(res);
            this.temPermissaoGps = false;
            await this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.ACCESS_FINE_LOCATION);
        });

        await this.androidPermissions.requestPermissions([this.androidPermissions.PERMISSION.ACCESS_FINE_LOCATION, +
            this.androidPermissions.PERMISSION.GET_ACCOUNTS]);

        // Salvando no localStorage
        localStorage.setItem('gpsPermission', JSON.stringify(this.temPermissaoGps));
        return this.temPermissaoGps;
    }

    // Metodo para verificar permissao
    async getPermissaoGPSBackgound() {

        await this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.ACCESS_BACKGROUND_LOCATION).then((result: { hasPermission: boolean; }) => {
            console.log('Tem permissao de GPS background?', result.hasPermission);
            this.temPermissaoGps = result.hasPermission;
        }).catch(async (res: any) => {
            console.log(res);
            this.temPermissaoGps = false;
            await this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.ACCESS_BACKGROUND_LOCATION);
        });

        await this.androidPermissions.requestPermissions([this.androidPermissions.PERMISSION.ACCESS_BACKGROUND_LOCATION, +
            this.androidPermissions.PERMISSION.GET_ACCOUNTS]);

        // Salvando no localStorage
        localStorage.setItem('gpsPermissionBackground', JSON.stringify(this.temPermissaoGps));
        return this.temPermissaoGps;
    }

    // Permissão de acesso a pasta de armazenamento
    async getPermissaoArmazenamento() {

        await this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE).then((result: { hasPermission: boolean; }) => {
            console.log('Tem permissao de Armazenamento?', result.hasPermission);
            this.temPermissaoFile = result.hasPermission;
        }).catch(async (res: any) => {
            console.log(res);
            this.temPermissaoFile = false;
            await this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE);
        });

        await this.androidPermissions.requestPermissions([this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE, +
            this.androidPermissions.PERMISSION.GET_ACCOUNTS]);

        // Salvando no localStorage
        localStorage.setItem('filePermission', JSON.stringify(this.temPermissaoFile));
        return this.temPermissaoFile;
    }

    // Permissão de acesso a pasta de armazenamento
    async getPermissaoLeituraArmazenamento() {

        await this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.READ_EXTERNAL_STORAGE).then((result: { hasPermission: boolean; }) => {
            console.log('Tem permissao de Leitura de Armazenamento?', result.hasPermission);
            this.temPermissaoReadFile = result.hasPermission;
        }).catch(async (res: any) => {
            console.log(res);
            this.temPermissaoReadFile = false;
            await this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.READ_EXTERNAL_STORAGE);
        });

        await this.androidPermissions.requestPermissions([this.androidPermissions.PERMISSION.READ_EXTERNAL_STORAGE, +
            this.androidPermissions.PERMISSION.GET_ACCOUNTS]);

        // Salvando no localStorage
        localStorage.setItem('fileReadPermission', JSON.stringify(this.temPermissaoReadFile));
        return this.temPermissaoReadFile;
    }

}

